<template>
	<div class="content-card promotion-container">
		<!-- Top Navigation -->
		<div class="promotion-header">
			<div class="header-left">
				<h2 class="title-text active-title" @click="currentTab = 'dashboard'">分销推广</h2>
			</div>
			<div class="header-right">
				<span class="nav-link" :class="{ 'active-link': currentTab === 'commission' }"
					@click="currentTab = 'commission'">佣金明细</span>
				<span class="nav-link" :class="{ 'active-link': currentTab === 'withdraw' }"
					@click="currentTab = 'withdraw'">提现记录</span>
				<span class="nav-link" :class="{ 'active-link': currentTab === 'rules' }"
					@click="currentTab = 'rules'">推广规则</span>
			</div>
		</div>

		<!-- Dashboard Content -->
		<div v-if="currentTab === 'dashboard'">
			<!-- Assets Card -->
			<div class="assets-card">
				<div class="balance-section">
					<div class="amount-item">
						<div class="amount-value highlight">{{ stats.balance || '0.00' }}</div>
						<div class="amount-label">可提现余额（元）</div>
					</div>
					<div class="divider"></div>
					<div class="amount-item">
						<div class="amount-value secondary">{{ stats.totalCommission || '0.00' }}</div>
						<div class="amount-label">历史总收益（元）</div>
					</div>
				</div>
				<div class="withdraw-btn" @click="openWithdrawModal">提现</div>
			</div>

			<!-- Team Section -->
			<div class="team-section">
				<div class="section-title">
					<span class="orange-bar"></span>
					<h3>我的团队</h3>
					<span class="member-count">总人数：{{ stats.teamCount || 0 }}人</span>
				</div>

				<div class="member-list" v-if="teamMembers.length > 0">
					<div class="member-item" v-for="(member, index) in teamMembers" :key="index">
						<div class="member-info">
							<div class="avatar-wrapper">
								<img :src="member.avatar" alt="Avatar" />
							</div>
							<div class="details">
								<div class="name">{{ member.name }}</div>
								<div class="date">{{ member.date }}</div>
							</div>
						</div>
						<div class="commission-amount">{{ member.commission }}元</div>
					</div>
				</div>
				<EmptyState v-else description="暂无团队成员" />
			</div>

			<!-- Floating Invite Button -->
			<div class="invite-float-btn" @click="openInviteModal">
				<div class="red-packet-icon">
					<img src="../../assets/icon/inviteRedEnvelopes.png" alt="" />
				</div>
			</div>
		</div>

		<!-- Commission List Content -->
		<div v-if="currentTab === 'commission'" class="commission-list-container">
			<div class="commission-list" v-if="commissionList.length > 0">
				<div class="commission-item" v-for="(item, index) in commissionList" :key="index">
					<div class="item-left">
						<div class="item-title">{{ item.title }}</div>
						<div class="item-date">{{ item.date }}</div>
					</div>
					<div class="item-amount" :class="{ 'negative': item.amount < 0, 'positive': item.amount > 0 }">
						{{ item.amount > 0 ? '+' + item.amount.toFixed(1) : item.amount.toFixed(1) }}
					</div>
				</div>
			</div>
			<EmptyState v-else description="暂无佣金明细" />
			<div class="no-more" v-if="commissionList.length > 0">没有更多了</div>
		</div>

		<!-- Withdraw List Content -->
		<div v-if="currentTab === 'withdraw'" class="commission-list-container">
			<div class="commission-list" v-if="withdrawList.length > 0">
				<div class="commission-item" v-for="(item, index) in withdrawList" :key="index">
					<div class="item-left">
						<div class="item-title">
							{{ item.title }}
							<span v-if="item.rejectReason" class="reject-reason">
								① 拒绝原因：{{ item.rejectReason }}
							</span>
						</div>
						<div class="item-date">{{ item.date }}</div>
					</div>
					<div class="item-right">
						<div class="item-amount negative">{{ item.amount.toFixed(1) }}</div>
						<div class="item-status" :class="item.status">{{ item.statusText }}</div>
					</div>
				</div>
			</div>
			<EmptyState v-else description="暂无提现记录" />
			<div class="no-more" v-if="withdrawList.length > 0">没有更多了</div>
		</div>
		<!-- Promotion Rules Content -->
		<div v-if="currentTab === 'rules'" class="promotion-rules-container">
			<div class="rules-content" v-if="promotionRulesContent" v-html="promotionRulesContent"></div>
			<div class="rules-content" v-else>
				<h3 class="main-title">轻松分享，赚钱在握！</h3>
				<p class="sub-title">现在邀请好友买课或开通会员，你就能赚 最高10%佣金！🔥</p>

				<ul class="benefit-list">
					<li><span class="icon">✅</span> 好友购课，你赚佣金</li>
					<li><span class="icon">✅</span> 好友充值会员，你继续分红</li>
					<li><span class="icon">✅</span> 佣金实时到账，随时提现</li>
				</ul>

				<p class="description">
					不用投资、不用上课，人脉就是你的收入！分享专属邀请链接，好友下单，你坐等奖励！
				</p>

				<div class="chart-benefit">
					<span class="icon">📈</span> 佣金比例高 · 长期有效 · 上不封顶
				</div>

				<p class="cta-text">马上邀请，把知识分享变成真金白银！</p>

				<div class="action-trigger">
					<span class="icon">👉</span> 立即生成你的邀请链接，开始赚钱！
				</div>
			</div>
		</div>
		<!-- Withdraw Modal -->
		<div class="withdraw-modal-overlay" v-if="showWithdrawModal" @click.self="closeWithdrawModal">
			<div class="withdraw-modal">
				<div class="modal-header">
					<h3>提现</h3>
					<span class="close-btn" @click="closeWithdrawModal">&times;</span>
				</div>
				<div class="modal-tabs">
					<div class="tab-item" :class="{ active: withdrawTab === 'wechat' }" @click="withdrawTab = 'wechat'">
						微信提现
					</div>
					<div class="tab-item" :class="{ active: withdrawTab === 'bank' }" @click="withdrawTab = 'bank'">
						银行卡提现
					</div>
				</div>

				<div class="modal-body">
					<!-- Amount Input (Common) -->
					<div class="amount-section">
						<div class="amount-header">
							<span class="label">提现金额</span>
							<span class="balance-info">最多可提现金额 ¥{{ stats.balance || '0.00' }}</span>
						</div>
						<div class="input-amount-wrapper">
							<span class="currency-symbol">¥</span>
							<input type="number" v-model="withdrawAmount" placeholder="0.00" />
							<span class="withdraw-all-btn" @click="handleWithdrawAll">全部提现</span>
						</div>
					</div>

					<!-- WeChat Fields -->
					<div v-if="withdrawTab === 'wechat'" class="wechat-section">
						<div class="form-group">
							<label>上传微信收款码</label>
							<div class="upload-box" @click="triggerFileInput">
								<div v-if="withdrawImageUrl" class="preview-image">
									<img :src="withdrawImageUrl" alt="收款码" />
									<span class="remove-btn" @click.stop="removeImage">&times;</span>
								</div>
								<div v-else class="upload-placeholder">
									<div class="icon">
										<svg width="24" height="24" viewBox="0 0 48 48" fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M40 12H8C5.79086 12 4 13.7909 4 16V36C4 38.2091 5.79086 40 8 40H40C42.2091 40 44 38.2091 44 36V16C44 13.7909 42.2091 12 40 12Z"
												fill="none" stroke="#999999" stroke-width="3" stroke-linejoin="round" />
											<path
												d="M4 28L14.0006 20.0095C15.1263 19.1101 16.756 19.1671 17.8126 20.1432L26 28"
												stroke="#999999" stroke-width="3" stroke-linecap="round"
												stroke-linejoin="round" />
											<path
												d="M22 32L27.9994 27.0095C29.1251 26.1101 30.7548 26.1671 31.8114 27.1432L44 38"
												stroke="#999999" stroke-width="3" stroke-linecap="round"
												stroke-linejoin="round" />
											<path
												d="M32 20C33.1046 20 34 19.1046 34 18C34 16.8954 33.1046 16 32 16C30.8954 16 30 16.8954 30 18C30 19.1046 30.8954 20 32 20Z"
												fill="none" stroke="#999999" stroke-width="3" stroke-linejoin="round" />
										</svg>
									</div>
									<div class="text">上传图片</div>
								</div>
								<input type="file" ref="fileInput" accept="image/*" @change="handleFileChange"
									style="display: none" />
							</div>
						</div>
					</div>

					<!-- Bank Fields -->
					<div v-else class="bank-section">
						<div class="form-group">
							<label>真实姓名</label>
							<input type="text" class="input-field" v-model="form.realName" placeholder="请输入持卡人姓名" />
						</div>
						<div class="form-group">
							<label>开户行</label>
							<input type="text" class="input-field" v-model="form.openingBank" placeholder="请输入开户银行" />
						</div>
						<div class="form-group">
							<label>银行卡号</label>
							<input type="text" class="input-field" v-model="form.bankNo" placeholder="请输入银行卡号" />
						</div>
						<div class="form-group">
							<label>预留电话</label>
							<input type="text" class="input-field" v-model="form.phone" placeholder="请输入银行预留手机号" />
						</div>
						<div class="form-group">
							<label>身份证号 <span class="sub-label">(选填)</span></label>
							<input type="text" class="input-field" v-model="form.idCard" placeholder="请输入身份证号" />
						</div>
					</div>

					<div class="withdraw-tips">
						<p>提现说明：</p>
						<p>1.提现将收取一定的手续费。</p>
						<p>2.提现金额将会于三个工作日内到账，请注意查收。</p>
					</div>
					<button class="submit-btn" @click="submitWithdraw">立即提现</button>
				</div>
			</div>
		</div>

		<!-- 邀请好友弹窗 -->
		<div class="invite-modal-overlay" v-if="showInviteModal" @click.self="closeInviteModal">
			<div class="invite-modal">
				<span class="invite-modal-close" @click="closeInviteModal">&times;</span>
				<!-- <div class="invite-modal-ribbon">COUPON</div> -->
				<!-- 	<div class="invite-modal-header">
					<h3>邀请</h3>
				</div> -->
				<div class="invite-modal-body">
					<div class="invite-qrcode-wrap">
						<img :src="inviteQrCodeUrl" alt="邀请二维码" class="invite-qrcode" />
					</div>
					<p class="invite-desc">二维码分享给好友扫一扫绑定用户关系</p>
					<div class="invite-copy-btn" @click="copyInviteLink">复制链接</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { withdraw } from '@/api/user'
	import request from '@/utils/request'
	import {
		uploadFile
	} from '@/api/common'
	import EmptyState from '@/components/EmptyState.vue'

	export default {
		name: 'PromotionCenter',
		components: {
			EmptyState
		},
		data() {
			return {
				currentTab: 'dashboard', // dashboard, commission, withdraw, rules
				stats: {
					balance: 0,
					totalCommission: 0,
					totalWithdraw: 0,
					pendingWithdraw: 0,
					teamCount: 0
				},
				showWithdrawModal: false,
				form: {
					amount: '',
					method: 'bank', // bank, alipay, wechat
					account: '',
					name: '',
					bankNo: '',
					openingBank: '',
					phone: '',
					realName: '',
					idCard: ''
				},
				commissionList: [],
				withdrawList: [],
				teamMembers: [],
				inviteLink: 'https://longbu2026.com/register?inviteCode=123456',
				shareCopied: false,
				withdrawTab: 'wechat',
				withdrawAmount: '',
				withdrawImageUrl: '',
				promotionRulesContent: '',
				showInviteModal: false
			}
		},
		computed: {
			inviteQrCodeUrl() {
				const link = this.generateInviteLink()
				if (!link) return ''
				return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(link)}`
			}
		},
		created() {
			this.getPromotionStats()
			this.getCommissionLogs()
			this.getWithdrawLogs()
			this.getTeamMembersList()
			this.getSettings()
		},
		mounted() {},
		methods: {
			// 获取推广规则
			async getSettings() {
				try {
					const res = await request.get('/public/getSetting', {
						params: {
							// name: 'distribution_intro'
						}
					})
					if (res) {
						if (typeof res === 'object') {
							this.promotionRulesContent = res.distribution_intro || res.value || res.content || res
								.intro || ''
						} else {
							this.promotionRulesContent = res
						}
					}
				} catch (error) {
					console.error('获取推广规则失败:', error)
				}
			},
			// 获取推广统计（余额、总收益等）
			async getPromotionStats() {
				try {
					const res = await request.get('/api/user/promotion/stats')
					if (res) {
						this.stats = {
							balance: Number(res.balance || res.available || 0),
							totalCommission: Number(res.totalCommission || res.total || 0),
							totalWithdraw: Number(res.totalWithdraw || res.withdraw || 0),
							pendingWithdraw: Number(res.pendingWithdraw || res.pending || 0),
							teamCount: Number(res.teamCount || res.members || 0)
						}
					}
				} catch (error) {
					console.error('获取推广统计失败:', error)
				}
			},
			// 佣金明细
			async getCommissionLogs() {
				try {
					const res = await request.get('/api/user/commissionLogs')
					if (res) {
						const list = Array.isArray(res) ? res : (res.rows || [])
						this.commissionList = list.map(item => ({
							title: item.title || item.type || item.remark || '佣金变动',
							date: item.createTime || item.date || '',
							amount: Number(item.amount || item.commission || 0)
						}))
					}
				} catch (error) {
					console.error('获取佣金明细失败:', error)
				}
			},
			// 提现记录
			// 提现记录
			async getWithdrawLogs() {
				try {
					const res = await request.get('/api/user/withdrawLogs')
					if (res) {
						const list = Array.isArray(res) ? res : (res.rows || [])
						this.withdrawList = list.map(item => {
							let status = 'pending'
							let statusText = '审核中'

							if (item.status === 1 || item.status === 'success' || item.status ===
								'completed') {
								status = 'completed'
								statusText = '已提现'
							} else if (item.status === 2 || item.status === 'reject' || item.status ===
								'rejected') {
								status = 'rejected'
								statusText = '已拒绝'
							}

							return {
								title: item.title || `提现到${item.channel || '账户'}`,
								date: item.createTime || item.date || '',
								amount: -Math.abs(item.amount || item.money || 0),
								status: status,
								statusText: statusText,
								rejectReason: item.rejectReason || item.remark || ''
							}
						})
					}
				} catch (error) {
					console.error('获取提现记录失败:', error)
				}
			},
			// 我的团队
			async getMyTeam() {
				try {
					const res = await request.get('/api/user/myTeam')
					if (res) {
						// Check if res is a Promise object (unlikely if awaited, but user report says [object Promise])
						// The issue is likely how 'res' is being rendered in template or handled.
						// Wait, user says "[object Promise]" is displayed in the UI.
						// In template: <div class="member-item" v-for="(member, index) in teamMembers" ...>
						// If teamMembers contains Promises?
						// Or if stats.teamCount is a Promise?
						
						const list = Array.isArray(res) ? res : (res.rows || [])
						this.teamMembers = list.map(item => ({
							name: item.nickName || item.userName || `用户${item.userId || ''}`,
							date: item.createTime || item.joinTime || '',
							commission: item.contribution,
							avatar: item.avatar ||
								'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
						}))
					}
				} catch (error) {
					console.error('获取团队列表失败:', error)
				}
			},
			// 兼容旧命名，内部直接调用 getMyTeam 和 getPromotionStats
			// This was async, but user might be calling it without await in template or created hook causing Promise to be returned if used as data?
			// But getTeamMembers is a method.
			// Wait, the screenshot shows "[object Promise]" in the list area.
			// <div class="member-list" v-if="teamMembers.length > 0">
			// The EmptyState says "暂无团队成员" if else.
			// If [object Promise] is displayed, it means {{ somePromise }} is in the template.
			// Check template usage.
			// Template: <EmptyState v-else description="暂无团队成员" />
			// If teamMembers is [Promise], then v-for works but renders Promise?
			// Or maybe the error is in <div class="member-item">...</div>
			
			// Re-reading code:
			// async getTeamMembers() { await this.getMyTeam() }
			// calling this.getTeamMembers() in created() returns a Promise.
			// But it's not assigned to data.
			
			// Wait, look at line 427 in original file (before my edit):
			// async getTeamMembers() {
			//    await this.getMyTeam()
			// },
			
			// Maybe the issue is imports? 
			// import { getTeamMembers, ... } from '@/api/promotion'
			// And then in methods: { getTeamMembers } (shorthand for getTeamMembers: getTeamMembers)
			// But I also defined `async getTeamMembers() { ... }` in methods.
			// Vue methods override imported functions if names collide?
			// Or maybe `getTeamMembers` from API is being used directly in template?
			// No, template uses `teamMembers` data property.
			
			// Let's look at `import { ..., getTeamMembers, ... } from '@/api/promotion'`
			// And `methods: { ..., async getTeamMembers() { ... } }`
			// This collision is fine, method wins on `this`.
			
			// However, if `teamMembers` data property is assigned a Promise...
			// In `getMyTeam`, `this.teamMembers = list.map(...)`. This is synchronous array creation.
			
			// Is it possible `EmptyState` component is rendering slot content that is a Promise?
			
			// Let's check `src/api/promotion.js` content.
			// If `request.get` returns a Promise that resolves to `[object Promise]` string? Unlikely.
			
			// Wait, I see `[object Promise]` in the screenshot *below* "我的团队 总人数: 0人".
			// It looks like it's in the place where the list should be.
			// But "总人数: 0人" implies `stats.teamCount` is 0.
			// If `teamMembers.length` is 0, then `<EmptyState>` is shown.
			// Does `<EmptyState>` have a bug?
			
			// Or is `teamMembers` actually a Promise object?
			// `this.teamMembers = list.map(...)`
			
			// Let's rename the method to avoid collision just in case.
			getTeamMembersList() {
				this.getMyTeam()
			},
			openInviteModal() {
				this.showInviteModal = true
			},
			closeInviteModal() {
				this.showInviteModal = false
			},
			generateInviteLink() {
				try {
					const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
					const userId = userInfo.userId || userInfo.id || userInfo.user_id
					if (!userId) {
						return ''
					}
					return `https://mobile.longbu2026.com/?id=${userId}`
				} catch (e) {
					return ''
				}
			},
			async copyInviteLink() {
				const link = this.generateInviteLink() || (typeof window !== 'undefined' ? window.location.href : '')
				try {
					await navigator.clipboard.writeText(link)
					this.$message && this.$message.success('链接已复制')
				} catch (err) {
					try {
						const input = document.createElement('input')
						input.value = link
						document.body.appendChild(input)
						input.select()
						document.execCommand('copy')
						document.body.removeChild(input)
						this.$message && this.$message.success('链接已复制')
					} catch (e2) {
						alert('复制失败，请手动复制：' + link)
					}
				}
			},
			openWithdrawModal() {
				this.showWithdrawModal = true
			},
			closeWithdrawModal() {
				this.showWithdrawModal = false
				this.withdrawAmount = ''
				this.form = {
					realName: '',
					idCard: '',
					bankNo: '',
					phone: '',
					openingBank: ''
				}
				this.removeImage()
			},
			triggerFileInput() {
				this.$refs.fileInput.click()
			},
			handleFileChange(event) {
				const file = event.target.files[0]
				if (file) {
					if (!file.type.startsWith('image/')) {
						alert('请上传图片文件')
						return
					}
					if (file.size > 5 * 1024 * 1024) {
						alert('图片大小不能超过5MB')
						return
					}
					this.withdrawImage = file
					this.withdrawImageUrl = URL.createObjectURL(file)
				}
			},
			removeImage() {
				this.withdrawImage = null
				this.withdrawImageUrl = ''
				if (this.$refs.fileInput) {
					this.$refs.fileInput.value = ''
				}
			},
			handleWithdrawAll() {
				this.withdrawAmount = this.stats.balance
			},
			async submitWithdraw() {
				if (!this.withdrawAmount || Number(this.withdrawAmount) <= 0) {
					alert('请输入有效的提现金额')
					return
				}
				if (Number(this.withdrawAmount) > Number(this.stats.balance)) {
					alert('提现金额不能超过余额')
					return
				}

				const params = {
					amount: Number(this.withdrawAmount),
					type: this.withdrawTab === 'wechat' ? 1 : 2,
					realName: this.form.realName,
					idCard: this.form.idCard
				}

				if (params.type === 1) {
					if (!this.withdrawImage) {
						alert('请上传微信收款码')
						return
					}

					// Upload image first
					try {
						const formData = new FormData()
						formData.append('file', this.withdrawImage)
						const uploadRes = await uploadFile(formData)
						if (uploadRes && (uploadRes.url || uploadRes.fileName)) {
							// Assuming the API expects the image URL or path in a field like 'codeUrl' or 'image'
							// Based on typical implementations where 'codeUrl' stores the payment code image
							params.image = uploadRes.url || uploadRes.fileName
						} else {
							alert('图片上传失败')
							return
						}
					} catch (error) {
						console.error('上传图片失败:', error)
						alert('图片上传失败')
						return
					}
				} else {
					// 银行卡提现校验
					if (!params.realName) {
						alert('请输入真实姓名')
						return
					}
					if (!this.form.bankNo) {
						alert('请输入银行卡号')
						return
					}
					if (!this.form.openingBank) {
						this.$message.warning('请输入开户行')
						return
					}
					if (!this.form.phone) {
						this.$message.warning('请输入预留电话')
						return
					}
					params.bankNo = this.form.bankNo
					params.openingBank = this.form.openingBank
					params.phone = this.form.phone
				}

				try {
					await withdraw(params)
					this.$message.success('提现申请已提交')
					this.closeWithdrawModal()
					this.getWithdrawLogs() // Refresh logs
					this.getPromotionStats() // Refresh balance
				} catch (error) {
					console.error('提现失败:', error)
					// request.js usually handles error display, otherwise alert(error.msg || '提现失败')
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.content-card {
		background-color: #1e1e1e;
		border-radius: 4px;
		min-height: 600px;
		padding: 30px 40px;
		border-bottom: 1px solid #333;
		position: relative;

		&.promotion-container {
			padding: 0; // Reset padding
		}

		.promotion-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 40px;
			border-bottom: 1px solid #333;
			height: 60px;

			.header-left {
				.title-text {
					font-size: 16px;
					color: #ddd;
					font-weight: normal;
					position: relative;
					padding-bottom: 18px;
					margin: 0;
					top: 1px;
					cursor: pointer;

					&.active-title {
						border-bottom: 2px solid #ff9900;
					}
				}
			}

			.header-right {
				display: flex;
				gap: 30px;

				.nav-link {
					color: #999;
					font-size: 14px;
					cursor: pointer;

					&:hover {
						color: #fff;
					}

					&.active-link {
						color: #ff9900;
					}
				}
			}
		}

		.assets-card {
			margin: 20px 40px;
			background-image: url('@/assets/image/commissionBackground.png');
			background-size: 100% 100%;
			background-repeat: no-repeat;
			background-position: center;
			border-radius: 12px;
			padding: 20px 60px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			position: relative;
			overflow: hidden;
			border: 1px solid #333;

			.balance-section {
				display: flex;
				align-items: center;
				gap: 60px;
				z-index: 1;

				.divider {
					width: 1px;
					height: 40px;
					background-color: #444;
				}

				.amount-item {
					.amount-value {
						font-size: 30px;
						font-weight: bold;
						margin-bottom: 10px;
						font-family: 'Arial', sans-serif;

						&.highlight {
							color: #ffde8a; // Gold color
						}

						&.secondary {
							font-size: 20px;
							color: #dcb46e; // Darker gold
						}
					}

					.amount-label {
						color: #999;
						font-size: 14px;
					}
				}
			}

			.withdraw-btn {
				cursor: pointer;
				width: 100px;
				height: 42px;
				background: #FE8E04;
				box-shadow: 0px 1px 6px 0px rgba(104, 100, 93, 0.37);
				border-radius: 6px 6px 6px 6px;
				text-align: center;
				line-height: 42px;
				font-size: 18px;


			}

			.coin-bg {
				position: absolute;
				right: -20px;
				bottom: -40px;
				width: 150px;
				height: 150px;
				background: radial-gradient(circle, #ffd700 0%, transparent 70%);
				opacity: 0.1;
				border-radius: 50%;
			}
		}

		.team-section {
			padding: 0 40px;

			.section-title {
				display: flex;
				align-items: center;
				gap: 10px;
				margin-bottom: 20px;

				.orange-bar {
					width: 4px;
					height: 16px;
					background-color: #ff9900;
					border-radius: 2px;
				}

				h3 {
					font-size: 16px;
					color: #ddd;
					font-weight: normal;
					margin: 0;
				}

				.member-count {
					color: #999;
					font-size: 14px;
					margin-left: 10px;
				}
			}

			.member-list {
				.member-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 20px 0;
					border-bottom: 1px solid #333;

					&:last-child {
						border-bottom: none;
					}

					.member-info {
						display: flex;
						align-items: center;
						gap: 15px;

						.avatar-wrapper {
							width: 40px;
							height: 40px;
							border-radius: 50%;
							overflow: hidden;
							background-color: #333;

							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}

						.details {
							.name {
								color: #ddd;
								font-size: 14px;
								margin-bottom: 4px;
							}

							.date {
								color: #666;
								font-size: 12px;
							}
						}
					}

					.commission-amount {
						color: #ffde8a;
						font-size: 16px;
					}
				}
			}
		}

		.invite-float-btn {
			position: absolute;
			right: -100px;
			top: 200px;
			cursor: pointer;
			transition: transform 0.3s;

			&:hover {
				transform: scale(1.05);
			}

			.red-packet-icon {
				img {
					width: 114px;
					height: 123px;
				}
			}
		}

		.commission-list-container {
			padding: 0 40px;
			margin-top: 20px;

			.commission-list {
				.commission-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 20px;
					border: 1px solid #333;
					border-radius: 8px;
					margin-bottom: 15px;

					.item-left {
						.item-title {
							font-size: 16px;
							color: #ccc;
							margin-bottom: 8px;

							.reject-reason {
								color: #ff4d4f;
								font-size: 12px;
								margin-left: 10px;
								display: inline-block;
								vertical-align: middle;
							}
						}

						.item-date {
							font-size: 12px;
							color: #666;
						}
					}

					.item-amount {
						font-size: 18px;
						font-family: Arial, sans-serif;

						&.negative {
							color: #ccc;
						}

						&.positive {
							color: #fff;
						}
					}

					.item-right {
						text-align: right;

						.item-amount {
							font-size: 18px;
							font-family: Arial, sans-serif;
							margin-bottom: 4px;
							color: #ccc;
						}

						.item-status {
							font-size: 12px;

							&.pending {
								color: #ffde8a;
							}

							&.rejected {
								color: #ff4d4f;
							}

							&.completed {
								color: #52c41a;
							}
						}
					}
				}
			}

			.no-more {
				text-align: center;
				color: #666;
				font-size: 12px;
				padding: 30px 0;
			}
		}

		.promotion-rules-container {
			padding: 40px;
			color: #ccc;

			.rules-content {
				.main-title {
					font-size: 20px;
					color: #fff;
					margin-bottom: 15px;
					font-weight: normal;
				}

				.sub-title {
					font-size: 14px;
					color: #ccc;
					margin-bottom: 25px;
				}

				.benefit-list {
					list-style: none;
					padding: 0;
					margin-bottom: 25px;

					li {
						display: flex;
						align-items: center;
						margin-bottom: 15px;
						font-size: 14px;
						color: #ddd;

						.icon {
							margin-right: 10px;
							font-size: 16px;
						}
					}
				}

				.description {
					font-size: 14px;
					line-height: 1.6;
					margin-bottom: 20px;
					color: #ddd;
				}

				.chart-benefit {
					display: flex;
					align-items: center;
					margin-bottom: 30px;
					font-size: 14px;
					color: #ddd;

					.icon {
						margin-right: 10px;
						font-size: 16px;
					}
				}

				.cta-text {
					font-size: 14px;
					margin-bottom: 15px;
					color: #ddd;
				}

				.action-trigger {
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #fff;
					cursor: pointer;

					.icon {
						margin-right: 10px;
						font-size: 16px;
					}

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}

	.withdraw-modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 2000;

		.withdraw-modal {
			background: #fff;
			width: 500px;
			box-sizing: border-box; // Fix width calculation
			border-radius: 12px;
			padding: 20px 30px;
			color: #333;
			position: relative;

			.modal-header {
				text-align: center;
				position: relative;
				margin-bottom: 20px;

				h3 {
					font-size: 18px;
					font-weight: normal;
					margin: 0;
					color: #333;
				}

				.close-btn {
					position: absolute;
					right: 0;
					top: 0;
					font-size: 24px;
					color: #999;
					cursor: pointer;
					line-height: 1;

					&:hover {
						color: #333;
					}
				}
			}

			.modal-tabs {
				display: flex;
				border-bottom: 1px solid #eee;
				margin-bottom: 25px;

				.tab-item {
					flex: 1;
					text-align: center;
					padding-bottom: 12px;
					font-size: 16px;
					color: #666;
					cursor: pointer;
					position: relative;

					&.active {
						color: #ff9900;
						font-weight: bold;

						&::after {
							content: '';
							position: absolute;
							bottom: -1px;
							left: 50%;
							transform: translateX(-50%);
							width: 40px;
							height: 3px;
							background-color: #ff9900;
							border-radius: 2px;
						}
					}
				}
			}

			.modal-body {
				padding-top: 10px;

				.amount-section {
					margin-bottom: 30px;

					.amount-header {
						display: flex;
						align-items: baseline;
						margin-bottom: 15px;

						.label {
							font-size: 14px;
							font-weight: bold;
							color: #333;
						}

						.balance-info {
							font-size: 12px;
							color: #999;
							margin-left: 10px;
						}
					}

					.input-amount-wrapper {
						display: flex;
						align-items: center;
						border-bottom: 1px solid #eee;
						padding-bottom: 10px;

						.currency-symbol {
							font-size: 30px;
							font-weight: bold;
							color: #333;
							margin-right: 10px;
						}

						input {
							flex: 1;
							min-width: 0;
							border: none;
							font-size: 40px;
							font-weight: bold;
							color: #333;
							outline: none;
							background: transparent;
							height: 50px;

							&::placeholder {
								color: #ccc;
							}

							/* Chrome, Safari, Edge, Opera */
							&::-webkit-outer-spin-button,
							&::-webkit-inner-spin-button {
								-webkit-appearance: none;
								margin: 0;
							}

							/* Firefox */
							&[type=number] {
								-moz-appearance: textfield;
							}
						}

						.withdraw-all-btn {
							color: #ff9900;
							font-size: 14px;
							cursor: pointer;
							margin-left: 10px;
							white-space: nowrap;
							flex-shrink: 0;
						}
					}
				}

				.wechat-section {
					margin-bottom: 30px;

					.form-group {
						label {
							display: block;
							font-size: 14px;
							color: #999;
							margin-bottom: 15px;
						}

						.upload-box {
							width: 100px;
							height: 100px;
							background-color: #f5f5f5;
							border-radius: 4px;
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							cursor: pointer;
							position: relative;
							overflow: hidden;

							.upload-placeholder {
								text-align: center;

								.icon {
									margin-bottom: 8px;
									display: flex;
									justify-content: center;
								}

								.text {
									font-size: 12px;
									color: #999;
								}
							}

							.preview-image {
								width: 100%;
								height: 100%;
								position: relative;

								img {
									width: 100%;
									height: 100%;
									object-fit: cover;
								}

								.remove-btn {
									position: absolute;
									top: 0;
									right: 0;
									width: 20px;
									height: 20px;
									background: rgba(0, 0, 0, 0.5);
									color: #fff;
									text-align: center;
									line-height: 18px;
									cursor: pointer;
									font-size: 16px;
									border-bottom-left-radius: 4px;
								}
							}
						}
					}
				}

				.bank-section {
					margin-bottom: 30px;

					.form-group {
						margin-bottom: 15px;

						label {
							display: block;
							font-size: 14px;
							color: #333;
							margin-bottom: 8px;

							.sub-label {
								color: #999;
								font-size: 12px;
								margin-left: 5px;
								font-weight: normal;
							}
						}

						.input-field {
							width: 100%;
							height: 40px;
							border: 1px solid #eee;
							border-radius: 4px;
							padding: 0 10px;
							font-size: 14px;
							color: #333;
							box-sizing: border-box;

							&:focus {
								outline: none;
								border-color: #ff9900;
							}

							&::placeholder {
								color: #ccc;
							}
						}
					}
				}

				.withdraw-tips {
					margin-bottom: 30px;

					p {
						margin: 5px 0;
						color: #999;
						font-size: 12px;
						line-height: 1.5;
					}
				}

				.submit-btn {
					width: 100%;
					height: 44px;
					background: #ff9900;
					border: none;
					border-radius: 4px;
					color: #fff;
					font-size: 16px;
					cursor: pointer;

					&:hover {
						opacity: 0.9;
					}
				}
			}
		}
	}

	.invite-modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.6);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 2000;
	}

	.invite-modal {
		position: relative;
		width: 448px;
		height: 490px;
		background: #fff url('../../assets/image/posterBackground.png') no-repeat center / cover;
		border-radius: 16px;
		overflow: hidden;
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
	}

	.invite-modal-close {
		position: absolute;
		right: 12px;
		top: 12px;
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		line-height: 1;
		cursor: pointer;
		z-index: 10;
	}

	.invite-modal-ribbon {
		position: absolute;
		top: 80px;
		width: 120px;
		padding: 6px 30px;
		// background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
		color: #fff;
		font-size: 12px;
		font-weight: bold;
		letter-spacing: 1px;
		text-align: center;
		transform: rotate(-45deg);
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
		z-index: 5;
	}

	.invite-modal-header {
		// background: linear-gradient(135deg, #ff6b35 0%, #f7931e 50%, #ff8c42 100%);
		padding: 24px 20px 20px;
		text-align: center;
	}

	.invite-modal-header h3 {
		margin: 0;
		font-size: 22px;
		font-weight: bold;
		color: #fff;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
	}

	.invite-modal-body {
		padding: 24px 20px 28px;
		text-align: center;
		padding-top: 120px;
	}

	.invite-qrcode-wrap {
		display: inline-block;
		padding: 12px;

		background: #fff;
		border: 1px solid #eee;
		border-radius: 8px;
		margin-bottom: 16px;
	}

	.invite-qrcode {
		display: block;
		width: 200px;
		height: 200px;
	}

	.invite-desc {
		margin: 0 0 20px;
		font-size: 14px;
		color: #333;
		line-height: 1.5;
	}

	.invite-copy-btn {
		margin: 0 auto;
		width: 146px;
		height: 28px;
		background: #FFF5EA;
		border-radius: 3px 3px 3px 3px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 13px;
		color: #FE8E04;
		line-height: 28px;
	}
</style>